
import { User, Role } from '../types';

export const authService = {
  hasPermission: (user: User | null, requiredRole: Role): boolean => {
    if (!user) return false;
    if (user.role === 'ADMIN') return true;
    if (user.role === 'EDITOR' && requiredRole !== 'ADMIN') return true;
    if (user.role === 'VIEWER' && requiredRole === 'VIEWER') return true;
    return false;
  }
};
